var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.routerView)?_c('Navigation'):_vm._e(),(!_vm.$route.meta.routerView)?_c('Aside'):_vm._e(),_c('div',{staticClass:"container",class:{ 'routerView': _vm.$route.meta.routerView }},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }